import { Route } from "react-router";

import { CommercialTransactionsLawPage } from "@/components/pages/policy/commercialTransactionsLaw/page";
import { PrivacyPolicyPage } from "@/components/pages/policy/privacy/page";
import { ServicePolicyPage } from "@/components/pages/policy/service/page";

import { PATHS } from "../paths";

export const PolicyRoute = (
	<>
		<Route path={PATHS.POLICY.SERVICE_POLICY} index element={<ServicePolicyPage />} />
		<Route path={PATHS.POLICY.PRIVACY_POLICY} index element={<PrivacyPolicyPage />} />
		<Route path={PATHS.POLICY.COMMERCIAL_TRANSACTIONS_LAW} index element={<CommercialTransactionsLawPage />} />
	</>
);
